import React, { useEffect } from 'react';
import checkboxImg from '@/assets/image/checkbox.svg';
import checkboxSelectImg from '@/assets/image/checkbox-select.svg';
import { storagePrefixV2 } from '@/constant';
import {
  setCurrentStep,
  setFormValue,
  setNextBtnConfig,
  setPrevBtnConfig,
  useAIDiagnoseStore,
} from '../../store/useAIDiagnoseStore';
import { ShowTitle } from '../show-title';

import cx from './index.module.scss';

interface Props {}

export type TPart = 'waistCircumference' | 'armCircumference' | 'thighCircumference' | 'backThickness';

export const PART_LIST: Array<{
  name: string;
  imgUrl: string;
  part: TPart;
}> = [
  {
    name: '腰腹塑形',
    imgUrl: storagePrefixV2 + '/ai-consulation/male-model-bg/adqfq.png',
    part: 'waistCircumference',
  },
  {
    name: '打造天鹅臂',
    imgUrl: storagePrefixV2 + '/ai-consulation/male-model-bg/sadascldqw.png',
    part: 'armCircumference',
  },
  {
    name: '纤细腿部',
    imgUrl: storagePrefixV2 + '/ai-consulation/male-model-bg/qwfskdkqfwq.png',
    part: 'thighCircumference',
  },
  {
    name: '轻薄背部',
    imgUrl: storagePrefixV2 + '/ai-consulation/male-model-bg/qfsdzczad.png',
    part: 'backThickness',
  },
];

export const SelectPart: React.FC<Props> = () => {
  const { selectPart } = useAIDiagnoseStore.use.formValue();

  useEffect(() => {
    setPrevBtnConfig({
      show: true,
      action: () => {
        setCurrentStep(prev => ({ currentStep: prev - 1 }));
      },
    });
    setNextBtnConfig({
      disable: !selectPart?.length,
      action: () => {
        setCurrentStep(prev => ({ currentStep: prev + 1 }));
      },
    });
  }, [selectPart?.length]);

  return (
    <div className={cx('SelectPart')}>
      <ShowTitle title="您想改善的部位是哪里" subTitle="可选多个部位" />
      <div className={cx('select-box')}>
        {PART_LIST.map(item => (
          <div
            key={item.part}
            className={cx('part-item', { selected: selectPart?.includes(item.part) })}
            onClick={() =>
              setFormValue({
                selectPart: selectPart?.includes(item.part)
                  ? selectPart.filter(part => part !== item.part)
                  : [...(selectPart || []), item.part],
              })
            }
          >
            <div className={cx('img-box')}>
              <img src={item.imgUrl} alt="" />
            </div>
            <div className={cx('name')}>{item.name}</div>
            <img
              src={selectPart?.includes(item.part) ? checkboxSelectImg : checkboxImg}
              alt=""
              className={cx('checkbox')}
            />
          </div>
        ))}
      </div>
    </div>
  );
};
